"use strict";

exports.__esModule = true;
exports.default = mergePaths;

function mergePaths(path1, path2) {
  var _path, _path2;

  (_path = path1) != null ? _path : path1 = "";
  (_path2 = path2) != null ? _path2 : path2 = "";
  return `${path1}${path2}`;
}